export const isGroupedListType = <T extends object>(
  list: T[] | GroupedListItem<T>[]
): list is GroupedListItem<T>[] => {
  const [item] = list;
  return typeof item === 'object' && 'title' in item && 'itemList' in item;
};

export type GroupedListItem<T> = {
  title: string;
  itemList: T[];
  isExpanded?: boolean;
  infoText?: string;
};
